import { Box } from "@mui/material";
import ExoForm from "../../components/exo/ExoForm";
import * as Yup from "yup";
import { API_PATCH, API_POST, DBRequest, useConfig } from "../../api/api";
import Feedback from "../../components/special/Feedback";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const NewSick = ({ onCreate, onCancle }) => {
  const { t } = useTranslation();

  const fields = [
    {
      label: t("Sickness"),
      type: "dateRange",
      key: "sickness",
    },
    {
      label: t("Comment"),
      type: "text",
      key: "comment",
      multiline: true,
    },
  ];

  const config = useConfig();

  const validationSchema = Yup.object().shape({
    sicknessStart: Yup.string().required(t("Start Date is required")),
    sicknessEnd: Yup.string().required(t("End Date is required")),
    comment: Yup.string().required(t("Comment is required")),
  });

  function handleSubmit(values) {
    const data = {
      type: "sick",
      comment: values.comment,
      values: JSON.stringify({
        startDate: values.dateRange.startDate,
        endDate: values.dateRange.endDate,
      }),
    };
    DBRequest({
      config,
      path: "employeerequests",
      method: API_POST(data),
      onResponse: handleCreation,
      onFeedback: handleAlertOpen,
    });
  }

  function handleCreation(data) {
    onCreate(data.data);
    onCancle();
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: "info",
    alertText: "test",
  });
  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <Box className="p-4">
      <ExoForm
        fields={fields}
        onSubmit={handleSubmit}
        onCancle={onCancle}
        header={t("New Sick Report")}
        validationSchema={validationSchema}
      />
      <Feedback setState={setAlertState} state={alertState} />
    </Box>
  );
};

export default NewSick;
